import { ButtonBase, withStyles } from '@material-ui/core';

export const StyledBackButton = withStyles({
  root: {
    borderRadius: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    background: 'rgba(51, 61, 71, 0.70)',
    position: 'absolute',
    top: 10,
    left: 10
  }
})(ButtonBase);
